/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Nav_StatusInputs */

const en_footer_nav_status = /** @type {(inputs: Footer_Nav_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const tr_footer_nav_status = /** @type {(inputs: Footer_Nav_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durum`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Footer_Nav_StatusInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const footer_nav_status = /** @type {((inputs?: Footer_Nav_StatusInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Nav_StatusInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_nav_status(inputs)
	return tr_footer_nav_status(inputs)
});